import findByIdOrThrow from '../../findByIdOrThrow'
import { WeaponTypeId } from './WeaponTypeId.enum'
import type { WeaponTypeMeta } from './WeaponTypeMeta.type'
import { weaponTypeMetaList } from './weaponTypeMetaList'

export default function getWeaponTypeMeta(wt_id: WeaponTypeId): WeaponTypeMeta {
  return findByIdOrThrow(weaponTypeMetaList, wt_id)
}
